export default "__VITE_ASSET__C3rZSlya__"